import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { IPackage } from '@/shared/interfaces/offer/package.interface'
import { EPaymentType } from '@/shared/enum/payment.enum'

export const usePackageStore = defineStore('package', () => {
  const packageSelected = ref<IPackage | null>(null)
  const paymentSelected = ref<EPaymentType>(EPaymentType.CREDIT_CARD)

  const hasUniquePaymentMethod = () => packageSelected.value?.paymentMethodsAllowed.length === 1

  const setPackage = (packageSelect: IPackage) => {
    packageSelected.value = packageSelect
  }

  const setPaymentSelect = (paymentSelect: EPaymentType) => {
    paymentSelected.value = paymentSelect
  }

  const getSupportPaymentPackage = () => {
    return packageSelected.value?.paymentMethodsAllowed
  }

  return {
    packageSelected,
    paymentSelected,
    setPackage,
    setPaymentSelect,
    hasUniquePaymentMethod,
    getSupportPaymentPackage
  }
})
